import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { OAuthService, OAuthErrorEvent, OAuthSuccessEvent } from 'angular-oauth2-oidc';
import { authConfig, environment } from "../../../environments/environment"
import { MechanicsService } from './mechanics.service';
import { instanceType } from '../utils';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs/internal/lastValueFrom';
import { RecentSearchesService } from './recentSearches.service';
import { PreferencesService } from '../_services/preferences.service';
import { QueryParamsService } from './queryParams.service';

@Injectable({
	providedIn: 'root'
})

export class AuthService {

	private isAuthenticatedNavBar: boolean = false;
	private isAuthenticatedApp: boolean = false;

	constructor(private oauthService: OAuthService,
		public ms: MechanicsService,
		public router: Router,
		public http: HttpClient,
		public rss: RecentSearchesService,
		public ps: PreferencesService,
		private qs: QueryParamsService
	) { }

	async _init():Promise<void> {
		try{
			//this.cleanOidcSessionStorage();
			await this.oauthService.loadDiscoveryDocumentAndTryLogin();

			// inspect the local storage to catch an inconsistency with the WIPO navbar
			// do we have WIPO navbar tokens?
			/*let navIdToken = localStorage.getItem('nav.idToken');
			let navAccessToken = localStorage.getItem('nav.accessToken');
			console.log("navIdToken: " + navIdToken);
			console.log("navAccessToken: " + navAccessToken);
			if (navIdToken && navAccessToken) {
				// if yes do we have a GBD access_token ?
				let accessToken = localStorage.getItem('access_token');
				console.log("accessToken: " + accessToken);
				if (!accessToken) {
					// if no, we have an inconsistency wipo nav bar / app
					// force logout at gbd/gdd level
					try {
						//this.oauthService.revokeTokenAndLogout();
					} catch(err) {
					   	console.log('wipoAuthService: revoke token/logout error:', err);
					}
					
					this.cleanOidcSessionStorage();
					//await this.oauthService.initImplicitFlow(encodeURIComponent(this.router.url));
					await this.oauthService.loadDiscoveryDocumentAndTryLogin();
					// sync the saved searches (in background)
					if (this.oauthService.hasValidIdToken()) {
						this.rss.loadSavedSearches();
					}
					await this.ps.loadPreferences(this.oauthService.hasValidIdToken());
				}
			}*/

		} catch(err) {
			console.log('wipoAuthService: loadDiscoveryDocumentAndTryLogin error:', err);
		}
	}

	async doSSO(): Promise<string> {

		const l = `AuthService doSSO() - `;
		console.log(`${l}router.url = ` , this.router.url);

		// https://www.npmjs.com/package/angular-oauth2-oidc

		this.oauthService.events.subscribe(event => {
			// just to catch some information to log
			if (event instanceof OAuthErrorEvent) {
			  	console.error('wipoAuthService: OAuthErrorEvent:', event);
			} else if (event instanceof OAuthSuccessEvent && event.type === 'silently_refreshed') {
			  	console.log(`wipoAuthService: OAuthEvent Access token REFRESHED, valid until: ${new Date(this.oauthService.getAccessTokenExpiration())}`);
			} /*else {
			  	console.log("wipoAuthService event: ", event);
			}*/
		});

		this.oauthService.configure(authConfig[instanceType()]);
		// refresh local token if the token life time is beyond configured limit
		this.oauthService.setupAutomaticSilentRefresh();

		// capture login event from wipo bar
		document.addEventListener('wipoLoginClick', async function (e) {
			//console.log("wipoLoginClick event");
			sessionStorage.setItem(`${instanceType()}.lggedFrom`, window.location.href);
			// oath module will theoretically redirect to this Uri
			// after successful login
			try {
				//console.log("wipoLoginClick event: oauthService initImplicitFlow");
				await this.oauthService.initImplicitFlow(encodeURIComponent(this.router.url));
				// sync the saved searches 
				if (this.oauthService.hasValidIdToken()) {
					await this.rss.loadSavedSearches();
					this.isAuthenticatedNavBar = true;
					this.isAuthenticatedApp = true;
				}
				await this.ps.loadPreferences(this.oauthService.hasValidIdToken());
				// we also need to set the rows parameter in the URL, otherwise the first next search will
				// take the URL parameter value rather than the prefered one
				this.qs.setQP("rows", this.ps.preferences["similarname"]["rows"], "similarname");
				this.qs.setQP("rows", this.ps.preferences["similarlogo"]["rows"], "similarlogo");
				this.qs.setQP("rows", this.ps.preferences["advancedsearch"]["rows"], "advancedsearch");
			} catch(err) {
			   	console.log('wipoAuthService: initImplicitFlow error:', err);
			}
		}.bind(this));

		// capture logout event from wipo bar
		document.addEventListener('wipoLogoutClick', async function (e) {
			//console.log("wipoLogoutClick event");
			try {
				let accessToken = localStorage.getItem('access_token');
				//console.log("access_token:");
				//console.log(accessToken);
				if (accessToken) {
					// all is fine
					//console.log("trigger oauthService logout");
					await this.oauthService.logOut();
					this.isAuthenticatedNavBar = false;
					this.isAuthenticatedApp = false;
				} else {
					// inconsistent wipo nav bar / app, it should not happen but...
					//console.log("no accessToken, force logout");
					this.isAuthenticatedApp = false;
					await this.oauthService.revokeTokenAndLogout();
					this.cleanOidcSessionStorage();
					//this.oauthService.loadDiscoveryDocumentAndTryLogin();
				}
			} catch(err) {
			   	console.log('wipoAuthService: logout error:', err);
			}
		}.bind(this));

		// capture authentication change event from wipo bar
		document.addEventListener('wipoAuthenticatedStatus', async function (e) {
			//console.log("wipoAuthenticatedStatus event");
			// the event carries a boolean value, true indicates a user login, and false indicates a user logout. 
			// the boolean is at e.detail.value, also available: e.target.username
			if (e.detail && e.detail.value) {
				// user is logged in the nav bar
				this.isAuthenticatedNavBar = true;
				let accessToken = localStorage.getItem('access_token');
				if (!accessToken) {
					// inconsistent wipo nav bar / app, trigger an app login
					try {
						await this.oauthService.loadDiscoveryDocumentAndTryLogin();
						// try to sync the saved searches 
						if (this.oauthService.hasValidIdToken()) {
							await this.rss.loadSavedSearches();
							this.isAuthenticatedApp = true;
						}
						await this.ps.loadPreferences(this.oauthService.hasValidIdToken());

						// we also need to set the rows parameter in the URL, otherwise the first next search will
						// take the URL parameter value rather than the prefered one
						this.qs.setQP("rows", this.ps.preferences["similarname"]["rows"], "similarname");
						this.qs.setQP("rows", this.ps.preferences["similarlogo"]["rows"], "similarlogo");
						this.qs.setQP("rows", this.ps.preferences["advancedsearch"]["rows"], "advancedsearch");
					} catch(err) {
					   	console.log('wipoAuthenticatedStatus/wipoAuthService: initImplicitFlow error:', err);
					}
				}
			} else {
				// user is not logged in the nav bar
				this.isAuthenticatedNavBar = false;
				let accessToken = localStorage.getItem('access_token');
				if (accessToken) {
					// inconsistent wipo nav bar / app, trigger an app logout
					try {
						await this.oauthService.logOut();
						this.isAuthenticatedApp = false;
					} catch(err) {
					   	console.log('wipoAuthenticatedStatus/wipoAuthService: initImplicitFlow error:', err);
					}
				}
			}
		}.bind(this));

		// check if user is logged in 
		//console.log(`${l}Starting userid get`);
		await this._init();
		if (this.oauthService.hasValidIdToken()) {
			this.isAuthenticatedApp = true;
			await this.rss.loadSavedSearches();
		}
		await this.ps.loadPreferences(this.oauthService.hasValidIdToken());
		let state:string = this.oauthService.state // user just logged in and the state is stored in the initImplicitFlow
			? decodeURIComponent(this.oauthService.state)
			: window.location.pathname + window.location.search;

		//console.log(`${l}state = `, state);
		return state;
	}
	
	private cleanOidcSessionStorage() {
		localStorage.removeItem('access_token');
		localStorage.removeItem('id_token');
		localStorage.removeItem('refresh_token');
		localStorage.removeItem('nonce');
		localStorage.removeItem('expires_at');
		localStorage.removeItem('id_token_claims_obj');
		localStorage.removeItem('id_token_expires_at');
		localStorage.removeItem('id_token_stored_at');
		localStorage.removeItem('access_token_stored_at');
		localStorage.removeItem('granted_scopes');
		localStorage.removeItem('session_state');

		// also clean nav bar keys to avoid appearing logged after logout...
		localStorage.removeItem('nav.accessToken');
		localStorage.removeItem('nav.idToken');
		localStorage.removeItem('nav.requestNonce');
		localStorage.removeItem('https://www3.wipo.int/alerts-manager/api/v2/alerts:count');
		localStorage.removeItem('https://www3.wipo.int/ePCT-API-IPPORTAL-basic/alerts');
		localStorage.removeItem('https://www3.wipo.int/portal-persistence/api/v1/preferences/bookmarkSwitch');
		localStorage.removeItem('https://www3.wipo.int/portal-persistence/api/v1/preferences/bookmarks');
	}

	get hasValidToken() { return this.oauthService.hasValidIdToken(); }
	get accessToken() { return this.oauthService.getAccessToken(); }
	get identityClaims() { return this.oauthService.getIdentityClaims(); }
	get idToken() { return this.oauthService.getIdToken(); }
	
}
